import React, { useEffect, useState } from 'react'
import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { useProperty } from '../../PropertyContext';
import { ReservationBookinglist } from '../../Services/Service';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as XLSX from "xlsx";
import "./ReservationReportTheme.css";

export const ReserTodayBookingReport = () => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [bookingData, setBookingData] = useState([]);
    const [filters, setFilters] = useState({
        BookingDate: "",
        GuestName: "",
        CheckInDate: "",
        CheckOutDate: "",
    });

    useEffect(() => {
        const fetchBookings = async () => {
            setLoading(true);
            try {
                const data = await ReservationBookinglist({ propertyID: selectedProperty.PropertyID });
                setBookingData((data || []));
            } catch (error) {
                console.log("Error fetching bookings", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBookings();
    }, [selectedProperty])

    const handleFilter = async () => {
        setLoading(true);
        try {
            // destroy old datatable
            // if (window.$.fn.DataTable.isDataTable(".basic-datatables")) {
            //     window.$(".basic-datatables").DataTable().destroy();
            // }

            const data = await ReservationBookinglist({
                propertyID: selectedProperty.PropertyID,
                BookingDate: filters.BookingDate,

            });

            setBookingData((data || []));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    const handleClear = async () => {
        setFilters({
            BookingDate: "",

        });
        const data = await ReservationBookinglist({
            propertyID: selectedProperty.PropertyID,
        });
        setBookingData((data || []));
    };

    const exportTodayBookingToExcel = () => {
    if (!bookingData || bookingData.length === 0) return;

    try {
        setLoading(true);

        const formattedData = bookingData.map((item, index) => {
            let email = "N/A";
            let mobile = "N/A";

            try {
                const gd = JSON.parse(item.GuestDetails);
                email = gd?.[0]?.EMailAddress || "N/A";
                mobile = gd?.[0]?.MobileNumber || "N/A";
            } catch {}

            return {
                "Sr#": index + 1,
                "BON REF. Id": item.BONRESID,
                "Conf. No": item.PMSRESID,
                "Check-in": item.CheckInDate,
                "Check-out": item.CheckOutDate,
                "Guest Name": item.GuestName,
                "Company": item.CompanyName,
                "Email": email,
                "Mobile No": mobile,
                "Total Payment": item.TotalPayment,
                "Payment Status": item.PaymentStatus,
                "Booking Status": item.BookingStatus,
                "Booking Date": item.BookingDate
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Today Booking Report");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Today_Booking_Report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (error) {
        console.error("Today Booking Export Error:", error);
    } finally {
        setLoading(false);
    }
};

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner reservation-report-page">

                            <div className="row">
                                <div className="col-md-12">
                                    <form>
                                        <div className='d-flex gap-3' style={{ placeContent: "flex-end" }}>
                                            <div>
                                                <input
                                                    className='form-control'
                                                    type='date'
                                                    value={filters.BookingDate}
                                                    onChange={(e) =>
                                                        setFilters({ ...filters, BookingDate: e.target.value })
                                                    }
                                                />
                                            </div>

                                            <div className='text-end mb-3'>
                                                <button
                                                    className='btn btn-primary me-2'
                                                    type='button'
                                                    onClick={handleFilter}
                                                >
                                                    Filter
                                                </button>
                                                <button className='btn btn-danger' type='button' onClick={handleClear}>Clear</button>
                                            </div>
                                        </div>
                                    </form>

                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-item-center'>
                                                <h4 className="card-title">Today booking report</h4>
                                                <button className='btn btn-sm btn-primary' type="button" onClick={exportTodayBookingToExcel}>Export</button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">

                                                {/* <table className="display table  table-bordered table-striped table-hover basic-datatables">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "45px" }}>Sr#</th>
                                                            <th style={{ width: "110px" }} >BON REF. Id</th>
                                                            <th style={{ width: "110px" }}>Conf. No</th>
                                                            <th style={{ width: "95px" }}>Check-in</th>
                                                            <th style={{ width: "110px" }}>Check-out</th>
                                                            <th >Guest Info</th>
                                                            <th>Moboile No</th>
                                                            <th style={{ width: "81px" }}>Payment </th>
                                                            <th style={{ width: "81px" }}>Status</th>
                                                            <th style={{ width: "95px" }}>Book On</th>

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {bookingData.map((item, index) => (
                                                            <tr key={item.ID}>
                                                                
                                                                <td>{index + 1}</td>
                                                                <td>{item.BONRESID}</td>
                                                                <td>{item.PMSRESID}</td>
                                                                <td>{item.CheckInDate}</td>
                                                                <td> {item.CheckOutDate}</td>
                                                                <td>
                                                                    <b>{item.GuestName}</b>
                                                                    <div>{item.CompanyName}</div>
                                                                    <div>Email: {(() => {
                                                                        try {
                                                                            const gd = JSON.parse(item.GuestDetails);
                                                                            return gd?.[0]?.EMailAddress || "N/A";
                                                                        } catch {
                                                                            return "N/A";
                                                                        }
                                                                    })()}</div>
                                                                </td>
                                                                <td>
                                                                    {(() => {
                                                                        try {
                                                                            const gd = JSON.parse(item.GuestDetails);
                                                                            return gd?.[0]?.MobileNumber || "N/A";
                                                                        } catch {
                                                                            return "N/A";
                                                                        }
                                                                    })()}
                                                                </td>

                                                                <td>
                                                                    <div> <span > ₹ {item.TotalPayment} </span></div>
                                                                    <div>
                                                                        <span
                                                                            className={
                                                                                item.PaymentStatus === "Paid"
                                                                                    ? "text-success"
                                                                                    : item.PaymentStatus === "Pending"
                                                                                        ? "text-warning"
                                                                                        : "text-secondary"
                                                                            }
                                                                        >
                                                                            {item.PaymentStatus || "N/A"}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className="text-center">
                                                                    <span
                                                                        className={
                                                                            item.BookingStatus === "Confirmed"
                                                                                ? "text-success"
                                                                                : item.BookingStatus === "Pending"
                                                                                    ? "text-warning"
                                                                                    : item.BookingStatus === "Cancelled"
                                                                                        ? "text-danger"
                                                                                        : "text-secondary"
                                                                        }
                                                                    >
                                                                        {item.BookingStatus || "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>{item.BookingDate}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table> */}


                                                <DataTable
                                                    value={bookingData}
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    showGridlines
                                                    stripedRows
                                                    responsiveLayout="scroll"
                                                    filterDisplay="menu"
                                                    
                                                    emptyMessage="No bookings found"
                                                >
                                                    <Column header="Sr#" body={(index) => index + 1} style={{ width: "45px" }} />
                                                    <Column field="BONRESID" header="BON REF. Id" sortable filter filterPlaceholder="Search" style={{ width: "110px" }} />
                                                    <Column field="PMSRESID" header="Conf. No" sortable filter filterPlaceholder="Search" style={{ width: "110px" }} />
                                                    <Column field="CheckInDate" header="Check-in" sortable filter filterPlaceholder="Search" style={{ width: "95px" }} />
                                                    <Column field="CheckOutDate" header="Check-out" sortable filter filterPlaceholder="Search" style={{ width: "110px" }} />

                                                    <Column header="Guest Info" body={(rowData) => {
                                                        let email = "N/A", mobile = "N/A";
                                                        try {
                                                            const gd = JSON.parse(rowData.GuestDetails);
                                                            email = gd?.[0]?.EMailAddress || "N/A";
                                                            mobile = gd?.[0]?.MobileNumber || "N/A";
                                                        } catch { }
                                                        return (
                                                            <div>
                                                                <b>{rowData.GuestName}</b>
                                                                <div>{rowData.CompanyName}</div>
                                                                <div>Email: {email}</div>
                                                                <div>Mobile: {mobile}</div>
                                                            </div>
                                                        )
                                                    }} />

                                                    <Column header="Payment" body={(rowData) => (
                                                        <div>
                                                            <div>₹ {rowData.TotalPayment}</div>
                                                            <div>
                                                                <span className={
                                                                    rowData.PaymentStatus === "Paid" ? "text-success" :
                                                                        rowData.PaymentStatus === "Pending" ? "text-warning" :
                                                                            "text-secondary"
                                                                }>
                                                                    {rowData.PaymentStatus || "N/A"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )} style={{ width: "81px" }} />

                                                    <Column header="Status" body={(rowData) => (
                                                        <span className={
                                                            rowData.BookingStatus === "Confirmed" ? "text-success" :
                                                                rowData.BookingStatus === "Pending" ? "text-warning" :
                                                                    rowData.BookingStatus === "Cancelled" ? "text-danger" :
                                                                        "text-secondary"
                                                        }>
                                                            {rowData.BookingStatus || "N/A"}
                                                        </span>
                                                    )} style={{ width: "81px" }} />

                                                    <Column field="BookingDate" header="Book On" sortable filter filterPlaceholder="Search" style={{ width: "95px" }} />

                                                </DataTable>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
